      import React from "react";
      import Announcement from "../components/Announcement";
      import Slider from "react-slick";
      import Header from "../components/Header";
      import FixMenu from "../components/FixMenu";
      import { Link } from "react-router-dom";
      import { Legend } from "recharts";

      const Legal = () => {
          const settings2 = {
              dots: true,
              infinite: true,
              speed: 500,
              slidesToShow: 1,
              slidesToScroll: 1,
              autoplay: true,
              autoplaySpeed: 3000,
              arrows: true,
            };
        return (
          <>
              <div id="bodyaddid">
              <Header />
              <FixMenu />
              <section className="main-banner">
                <div
                  className="innerpagebanner"
                  style={{
                    background: "url(" + "assets/img/inner/cost-data-book.jpg" + ")",
                    backgroundSize: "100% auto",
                  }}
                >
                  <div className="container">
                    <div className="row justify-content-center">
                      <div className="col-sm-10">
                        <h1>Quick Pay</h1>
                      </div>
                    </div>
                  </div>
                </div>
                <Announcement />
              </section>
              <section className="main_sectiods">
                <div className="container">
                  <div className="row justify-content-center padtops">
                    <div className="col-sm-12">
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                          <Link to="#">Home </Link>
                          <span className="icondsds">
                            <i className="fa fa-chevron-right" aria-hidden="true"></i>
                          </span>
                        </li>
                        <li className="breadcrumb-item">
                          <Link to="/legal                                                                                                                                                                 " className="active">
                          CGRFs & Ombudsman
                          </Link>
                        </li>
                      </ol>
                    </div>
                  </div>


                     {/* <div className="row justify-content-center">
                    <div className="col-sm-12">
                      <div className="row">
                      <div className="col-sm-12 bg_cols">
                      <div className="form_div wrapper-pd-top-login">
                      <div className="bs-example bs-example-1">
                      <legend style={{justifyContent:"center"}}>CONSUMER GRIEVANCE REDRESSAL FORUM GREATER NOIDA</legend>
                      <hr/>
                      <p style={{marginBottom:"20px"}}>An independent forum, called the Consumer Grievance Redressal Forum (CGRF), has been set up under Section 42 (5) of the Electricity Act, 2003 for redressal of consumer grievances regarding any dispute, other than theft or unauthorized use of electricity, in accordance with the regulation specified by the Uttar Pradesh Electricity Regulatory Commission (UPERC).</p>
                        <p style={{marginBottom:"24px"}}>If a consumer is not satisfied with the resolution of grievances by the Noida Power Company Limited, he/she can lodge a complaint with the Forum at the following address:</p>
                        <p style={{fontWeight:"bold" ,marginBottom:"25px"}}>Consumer Grievance Redressal Forum, Greater Noida<br/>33/11 kV Substation, D-Block,<br/>Sector Alpha-I, Opposite Ryan International School,<br/>Greater Noida, U.P. - 201310</p>
                        
                        <p  style={{marginBottom:"25px",}}>Note:  Formation of new CGRFs under UPERC (Consumer Grievance Redressal Forum) Regulations, 2022 are under consideration before the Hon’ble Uttar Pradesh Electricity Regulatory Commission. </p>

                        <hr style={{marginBottom:"25px"}}/>

                        <p style={{marginBottom:"25px"}}>Following are the members of the CGRF:</p>
                          <div className="col-sm-12" style={{marginBottom:"25px"}}>
                            <div className="row">
                            <div className="col-sm-4 text-center">
                            <div className="name" style={{fontWeight:"bold"}}>Name</div>
                                <div className="name"> Vacant </div>
                                <div className="name"> Vacant </div>
                                <div className="name">  Shri Jitendra Kumar Dhamat </div>
                                <div className="name">  Shri Sanyog Raizada </div>
                            </div>
                            <div className="col-sm-4 text-center">
                            <div className="name" style={{fontWeight:"bold"}}> Designation </div>
                                <div className="name"> Chairman </div>
                                <div className="name">  Technical Member </div>
                                <div className="name">  Member – Licensee </div>
                                <div className="name">  Secretary, CGRF </div>
                            </div>
                            <div className="col-sm-4 text-center">
                            <div className="name" style={{fontWeight:"bold"}}> Mobile No </div>
                                <div className="name"> - </div>
                                <div className="name"> - </div>
                                <div className="name"> 01204524203 </div>
                                <div className="name">  09911510997 </div>
                            </div>
                            </div>
                          </div>

                          
                        <p  style={{marginBottom:"25px"}}>The members of the forum will be available at the above mentioned address on all working days between 10.00AM to 5.00 PM. The forum will address all complaints related to supply and billing, but not cases concerning pilferage/theft/unauthorized use of electricity, which will be dealt by separate authorities.</p>
                        <p  style={{marginBottom:"15px"}}>Regulations and Guidelines for registering a complaint under Consumer Grievance Redressal Forum are provided both in English and Hindi in the following PDF file:</p>
                        <hr style={{marginBottom:"25px"}}/>
                        <Link to="assets/pdf/CGRF.pdf" target="_blank"><img src="assets/img/pdf.png" style={{display:"flex",margin:"auto"}}/></Link>
                        <span style={{textAlign:'center', display:"flow-root",marginBottom:"19px"}}>CGRF Regulations with Amendment</span>
                        <p style={{marginBottom:"18px"}}>Consumers, who are not satisfied with the decision of the Forum, may represent their case to the Ombudsman appointed by UPERC at:</p>
                        <div style={{fontSize:"bold"}}> Electricity Ombudsman<br/>Vidyut Niyamak Bhawan<br/>Vibhuti Khand, Gomti Nagar<br/>LUCKNOW-226010<br/>Telephone No:91-522-2720856<br/>Fax : +91-522-2720857<br/>Email: eo-up@uperc.org</div>
                      </div>
                      </div>
                      </div>
                      </div>
                    </div>
                  </div>     */}



             <div className="row justify-content-center">
                    <div className="col-sm-12" >
                      <div className="row">
                      <div className="col-sm-12 bg_cols" style={{padding:"20px 40px"}}>
                      <div className="form_div wrapper-pd-top-login">
                      <div className="bs-example bs-example-1">
                      <legend style={{justifyContent:"center"}}>CONSUMER GRIEVANCE REDRESSAL FORUM GREATER NOIDA</legend>
                      <hr/>
                      <p style={{marginBottom:"20px"}}> Three Consumer Grievance Redressal Forums [<strong>CGRFs</strong>], Greater Noida, (U.P.) have been established for the licensed area of Noida Power Company Limited on 29.09.2023 under Section 42(5) of Electricity Act, 2003, read with the UPERC (Consumer Grievance Redressal Forum) Regulations, 2022 [<strong> “CGRF Regulations 2022” </strong>] for redressal of consumer grievances regarding any dispute, other than theft or unauthorized use of electricity.  </p>
                        <p style={{marginBottom:"24px"}}>If a consumer is not satisfied with the resolution of grievances by the Company, he/she can approach the appropriate forum as per the jurisdiction of the CGRF as mentioned below:     </p>

                        
                        <p  style={{marginBottom:"25px",}}><strong><u>Pecuniary Rural Level </u></strong></p>

                      <p style={{marginBottom:"25px"}}><strong><u>Jurisdiction:</u></strong> Dispute related to rural bills and assessments less than Rs. 50 Lakh. </p>
                          <div className="col-sm-12" style={{marginBottom:"25px"}}>
                            <table className="table table-responsive" style={{border:"1px solid #ddd"}}>
                            <tr>
                              <th className="col-sm-3">Chairman</th>
                              <th  className="col-sm-2">First Nominated Member</th>
                              <th  className="col-sm-2">Second Nominated Member</th>
                              <th  className="col-sm-3">Third Nominated Member (Prosumer/Consumer)</th>
                              <th  className="col-sm-2">Independent Member</th>
                            </tr>
                            <tr>
                              <td>Shri Gaurav Sharma <br/> Senior Manager (Operations)</td>
                              <td> Shri Sunil Kumar

                                  </td>
                              <td>Shri Arun Mavi 

                                </td>
                              <td>Shri Virender Singh 

                              </td>
                              <td>Shri Sunil Kumar-Advocate

                                    </td>
                            </tr>
                            </table>
                      
                          </div>



                          <p  style={{marginBottom:"25px",}}><strong><u>Urban Level </u></strong></p>

                          <p style={{marginBottom:"25px"}}><strong><u>Pecuniary Jurisdiction:</u></strong> Dispute related to urban bills and assessments less than Rs. 50 Lakh. </p>
                            <div className="col-sm-12" style={{marginBottom:"25px"}}>
                              <table className="table table-responsive" style={{border:"1px solid #ddd"}}>
                              <tr>
                                <th className="col-sm-3">Chairman</th>
                                <th  className="col-sm-2">First Nominated Member</th>
                                <th  className="col-sm-2">Second Nominated Member</th>
                                <th  className="col-sm-3">Third Nominated Member (Prosumer/Consumer)</th>
                                <th  className="col-sm-2">Independent Member</th>
                              </tr>
                              <tr>
                                <td>Shri Jitender Dhamat <br/> Senior Manager (Operations) </td>
                                <td> Shri Mulendra Kumar Sharma </td>
                                <td> Shri Satya Prakash Sharma</td>
                                <td>Shri Prem Kumar </td>
                                <td> Smt. Veenita Marathia-Advocate  </td>
                              </tr>
                              </table>

                            </div>



                <p  style={{marginBottom:"25px",}}><strong><u>Company Level </u></strong></p>

                  <p style={{marginBottom:"25px"}}><strong><u>Pecuniary Jurisdiction:</u></strong> Dispute related to bills and assessments equal to and greater than Rs. 50 Lakh. </p>
                    <div className="col-sm-12" style={{marginBottom:"25px"}}>
                      <table className="table table-responsive" style={{border:"1px solid #ddd"}}>
                      <tr>
                        <th className="col-sm-3">Chairman</th>
                        <th  className="col-sm-2">First Nominated Member</th>
                        <th  className="col-sm-2">Second Nominated Member</th>
                        <th  className="col-sm-3">Third Nominated Member (Prosumer/Consumer)</th>
                        <th  className="col-sm-2">Independent Member</th>
                      </tr>
                      <tr>
                        <td>Shri Sanjiv Goel <br/> General Manager (Regulatory)</td>
                        <td> Shri Devi Ram </td>
                        <td> Shri A.D. Pandey  </td>
                        <td> Shri Omveer Singh  </td>
                        <td> - </td>
                      </tr>
                      </table>

                    </div>
                          
                        <p  style={{marginBottom:"25px"}}>Nature of Dispute, Pecuniary Jurisdiction of Forums and CGRF Regulations 2022 are provided in PDF in the below link:  </p>
                        <p  style={{marginBottom:"15px"}}> <a href="https://iwebapps.noidapower.com:8032/download/UPERC CGRF Regulations and NPCL's Approval.pdf" target="_blank" rel="noreferrer"><img src="assets/img/pdf.png" style={{ height:"50px" }} alt="NPCL"/></a> – CGRF Regulation 2022, Composition & Jurisdiction</p>

                        <div style={{marginBottom:"15px"}}> <strong>Address:</strong> <br />

                         Consumer Grievance Redressal Forum,  Greater Noida  <br/> [CGRF – Rural], [CGRF – Urban] and [CGRF – Company] ,<br/> 33/11 kV Substation, Sector Alpha - I, <br/> Sector Alpha-I, Opposite Ryan International School, <br/> Greater Noida, U.P. – 201310 <br/><br/><strong>Email: cgrf@noidapower.com</strong> <br/><strong>Telephone No: </strong>  &nbsp;&nbsp;&nbsp;&nbsp; 0120-6226644<br/><strong>Website:</strong> &nbsp;&nbsp; www.noidapower.com <br/><strong>Office Hours: </strong> 10.00 AM to 5.00 PM (Monday to Friday)  <br/></div>
                        <p style={{marginBottom:"18px"}}>The forums will address all complaints related to supply and billing, <strong><span className="itlc">excluding</span></strong> the cases relating to pilferage/theft/unauthorised use of electricity. The Consumers, who are not satisfied with decision of the Forum, may file an Appeal before <strong>the Company Level</strong> or the <strong>Hon’ble Ombudsman</strong> as prescribed in the Regulations 2022.</p>
                        <div className="col-sm-12">
                          <div className="row">
                              <div className="col-sm-6">

                              <div> <strong>Electricity Ombudsman</strong><br/>Vidyut Niyamak Bhawan<br/>Vibhuti Khand, Gomti Nagar<br/>Lucknow-226010<br/>Telephone No:91-522-2720856<br/>Fax : +91-522-2720857<br/>Email: eo-up@uperc.org</div>
                              </div>
                              <div className="col-sm-6">

                              <div> <strong>Company Level</strong>   <br/> <strong>Address: </strong>   Consumer Grievance Redressal <br/> Forum, Greater Noida <br/>33/11 kV Substation, D-Block, <br/> Sector Alpha-I, Opposite Ryan International  <br/> School, Greater Noida, U.P. – 201310 <br/><strong>Telephone:</strong>    0120-6226644 <br/> <strong>Email: </strong>cgrf@noidapower.com</div>
                              </div>
                        </div>
                      </div>
                      
                      </div>
                      </div>
                      </div>
                      </div>
                    </div>
                  </div>   
 
                </div>
              </section>
              </div>
          </>
        )
      }

      export default Legal